import { SettingOutlined } from '@ant-design/icons';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_CHANNEL_MEMBERS, GET_ME, Me, User } from '@frontend/data-access';
import { IdeaChannelCreate } from '@frontend/feature-idea-channel';
import { UserAvatar } from '@frontend/shared/ui';
import { Button, Modal, Skeleton } from 'antd';
import { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

function IdeaChannelReviewers({ channelId }: { channelId: string }) {
  const { t } = useTranslation('common');
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { data: meData } = useQuery<{ me: Me }>(GET_ME);
  const [getData, { data, loading }] = useLazyQuery<{
    getChannelMembers: {
      user: User;
    }[];
  }>(GET_CHANNEL_MEMBERS);

  useEffect(() => {
    getData({
      variables: {
        channelMemberType: 'CHANNEL_REVIEWER',
        channelId: channelId,
      },
    });
  }, [channelId, getData]);

  const handleOpenModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  const showSettings =
    meData?.me.role === 'ADMIN' ||
    data?.getChannelMembers.some((item) => item.user.id === meData?.me.id);

  if (loading) {
    return (
      <div className="flex gap-1">
        <Skeleton.Avatar active shape="circle" />
        <Skeleton.Avatar active shape="circle" />
        <Skeleton.Avatar active shape="circle" />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <div className="text-gray-900 text-sm font-medium">
        {t('channel_managers')}:
      </div>
      {data?.getChannelMembers.map((item, index) => (
        <UserAvatar key={index} user={item.user} size={32} />
      ))}
      {showSettings && (
        <Button shape="circle" onClick={handleOpenModal}>
          <SettingOutlined />
        </Button>
      )}

      <Modal
        width={1024}
        title={
          <span>
            <SettingOutlined style={{ marginRight: 8 }} />
            {t('channel_settings')}
          </span>
        }
        open={isOpenModal}
        onCancel={handleOpenModal}
        footer={null}
      >
        <IdeaChannelCreate
          id={channelId as string}
          onFinish={() => null}
          onCancel={() => null}
        />
      </Modal>
    </div>
  );
}

export default IdeaChannelReviewers;
